<template>
  <b-container fluid>
    <b-card no-body>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="8"
            >
              <b-form-group
                label-cols="12"
                label-for="input-default"
              >
                <v-select
                  id="id"
                  v-model="departmentSelected"
                  placeholder="Khoa/Bộ môn"
                  label="name"
                  :options="departments"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="text-right"
            >
              <b-form-group>
                <b-button
                  variant="primary"
                  @click="btnSearchClick()"
                >
                  <feather-icon
                    icon="SearchIcon"
                    class="align-text-top"
                  />
                  Tìm kiếm
                </b-button>
              </b-form-group>
            </b-col>
            <!-- Per Page -->
          </b-row>
          <b-row>
            <b-col cols="5">
              <b-form-file
                ref="inputFileRef"
                placeholder="Chọn file để import môn học..."
                drop-placeholder="Drop file here..."
                accept=".xls, .xlsx"
                @change="importExcel"
              />
            </b-col>
            <b-col cols="7">
              <div class="text-right">
                <b-button
                  v-show="showTableImport && (isSystemAdmin() || creatable)"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="info"
                  class="ml-1"
                  @click="handleImportSubject"
                >
                  <span class="text-nowrap text-right">
                    <feather-icon icon="CheckSquareIcon" /> Import môn học
                  </span>
                </b-button>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="ml-1"
                  @click="downloadFile"
                >
                  <span class="text-nowrap text-right">
                    <feather-icon icon="DownloadIcon" /> Tải file mẫu
                  </span>
                </b-button>

                <b-button
                  v-if="creatable"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.subjectSaveModal
                  variant="success"
                  class="ml-1"
                  @click="onCreateSubject"
                >
                  <span class="text-nowrap text-right">
                    <feather-icon icon="PlusIcon" /> Thêm môn học
                  </span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12">
              <div class="d-flex align-items-center mb-1 mt-0">
                <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                  đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                </span>
              </div>
              <vue-good-table
                v-show="!showTableImport"
                mode="remote"
                :columns="columns"
                :rows="subjectsDisplay"
                :pagination-options="paginationOptions"
                :total-rows="totalRows"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
              >
                <div
                  slot="emptystate"
                  style="text-align: center; font-weight: bold"
                >
                  Không có bản ghi nào !
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span v-if="props.column.field === 'status'">
                    {{ getStatusName(props.row.status) }}
                  </span>

                  <span v-else-if="props.column.field === 'subjectTypeId'">
                    {{ getSubjectTypeName(props.row.subjectTypeId) }}
                  </span>
                  <span v-else-if="props.column.field === 'totalCreditNum'">
                    {{ showCreditSummary(props.row) }}
                  </span>

                  <span v-else-if="props.column.field === 'action'">
                    <b-button
                      v-if="updatable"
                      v-b-modal.subjectSaveModal
                      variant="primary"
                      class="btn-icon"
                      size="sm"
                      @click="onEditSubject(props.row)"
                    >
                      <feather-icon icon="Edit2Icon" />
                    </b-button>
                    <b-button
                      v-if="deletable"
                      variant="danger"
                      class="btn-icon"
                      style="margin-left: 6px"
                      size="sm"
                      @click="onDeleteSubject(props.row)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </span>

                  <!-- Column: Common -->
                  <span v-else>{{
                    props.formattedRow[props.column.field]
                  }}</span>
                </template>

                <!-- pagination -->
                <template
                  slot="pagination-bottom"
                  slot-scope="props"
                >
                  <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                        đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap"> Hiển thị </span>
                      <b-form-select
                        v-model="filter.itemsPerPage"
                        :options="itemsPerPageOptions"
                        class="mx-1"
                        @input="(value) => props.perPageChanged({ currentPerPage: value })"
                      />
                      <span class="text-nowrap"> bản ghi/trang</span>
                    </div>
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="totalRows"
                        :per-page="filter.itemsPerPage"
                        class="mt-1 mb-0"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                      />
                    </div>
                  </div>
                </template>
              </vue-good-table>
              <vue-good-table
                v-show="showTableImport"
                :columns="tableImport.columns"
                :rows="tableImport.data"
                :pagination-options="paginationOptions"
              >
                <div
                  slot="emptystate"
                  style="text-align: center; font-weight: bold"
                >
                  Không có bản ghi nào !
                </div>

                <!-- pagination -->
                <template
                  slot="pagination-bottom"
                  slot-scope="props"
                >
                  <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap"> Hiển thị 1 đến </span>
                      <b-form-select
                        v-model="filterTableExcel.itemsPerPage"
                        :options="filterTableExcel.itemsPerPageOptions"
                        class="mx-1"
                        @input="
                          (value) =>
                            props.perPageChanged({ currentPerPage: value })
                        "
                      />
                      <span
                        class="text-nowrap"
                      >của {{ props.total }} bản ghi</span>
                    </div>
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="filterTableExcel.itemsPerPage"
                        class="mt-1 mb-0"
                        @input="
                          (value) => props.pageChanged({ currentPage: value })
                        "
                      />
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
    <SubjectSave
      ref="saveModalRef"
      :item="currentSubject"
      @succeed="onSucceed"
    />
  </b-container>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BFormFile,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import { showErrorToast, showSuccessToast, showWarningToast, showInfoToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import SubjectSave from '@/views/admin/category/subject/SubjectSave.vue'
import * as XLSX from 'xlsx'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'

export default {
  name: 'Subjects',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BFormGroup,
    VueGoodTable,
    BFormFile,
    vSelect,
    SubjectSave,
  },
  data() {
    return {
      subjectsDisplay: [],
      departmentSelected: undefined,
      subjectTypeSelected: undefined,
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        departmentId: '',
        subjectTypeId: '',
        name: '',
        code: '',
        status: 1,
        sort: '',
      },

      filterTableExcel: {
        currentPage: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [20, 30, 50, 80, 100],
      },

      currentSubject: undefined,
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'STT',
          field: 'rowNum',
          width: '5%',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Mã môn học',
          field: 'code',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          width: '15%',
          thClass: 'text-center',
        },
        {
          label: 'Tên môn học',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          width: '25%',
          thClass: 'text-center',
        },
        {
          label: 'Loại môn học',
          field: 'subjectTypeId',
          filterOptions: {
            placeholder: 'Tất cả',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: [],
          },
          width: '20%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            placeholder: 'Tất cả',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: [],
          },
          width: '15%',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Tín chỉ',
          field: 'totalCreditNum',
          sortable: true,
          width: '10%',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          width: '10%',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
      tableImport: {
        columns: [
          {
            label: 'STT',
            field: 'rowNum',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-right',
          },
          {
            label: 'Mã môn học',
            field: 'code',

            sortable: true,
            thClass: 'text-center',
          },
          {
            label: 'Tên môn học',
            field: 'name',
            sortable: true,
            thClass: 'text-center',
          },
          {
            label: 'Tên chính thức',
            field: 'mainName',
            sortable: true,
            thClass: 'text-center',
          },
          {
            label: 'Mã khoa',
            field: 'departmentCode',
            sortable: true,
            thClass: 'text-center',
          },
          {
            label: 'Mã loại môn học',
            field: 'subjectTypeCode',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Số tín chỉ lý thuyết',
            field: 'theoryCreditNum',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Số tín chỉ thực hành',
            field: 'practiceCreditNum',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Số tín chỉ thực tập',
            field: 'internshipCreditNum',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Tính điểm',
            field: 'countedForGpa',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Số tín chỉ quy đổi',
            field: 'totalCreditNum',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-right',
          },
        ],
        data: [],
        totalRows: 0,
      },
      showTableImport: false,
      tinChiLyThuyet: 0,
      tinChiThucHanh: 0,
    }
  },
  computed: {
    ...mapGetters({
      subjects: 'subject/subjects',
      totalRows: 'subject/totalRows',
      statuses: 'subject/statuses',
      departments: 'subject/departments',
      subjectTypes: 'subject/subjectTypes',
      systemParameters: 'parameter/dataLists',
    }),
    paginationOptions() {
      return {
        enabled: true,
        perPage: this.filterTableExcel.itemsPerPage,
      }
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.SUBJECT)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.SUBJECT)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.SUBJECT)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await Promise.all([
        this.begin({ organizationId: getUser().orgId }),
        this.getSystemParameters(),
      ])
      this.tinChiLyThuyet = this.systemParameters.find(item => item.code === 'LESSON_THEORY_CREDIT').value || 0
      this.tinChiThucHanh = this.systemParameters.find(item => item.code === 'LESSON_PRACTICE_CREDIT').value || 0
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      const subjectTypeCV = this.subjectTypes.map(item => ({
        value: item.id,
        text: item.name,
      }))
      const statusesCV = this.statuses.map(item => ({
        value: item.id,
        text: item.name,
      }))
      this.$set(
        this.columns[3].filterOptions,
        'filterDropdownItems',
        subjectTypeCV,
      )
      this.$set(
        this.columns[4].filterOptions,
        'filterDropdownItems',
        statusesCV,
      )
      this.isLoading = false
    }
    await this.getSubjectsFromStore()
  },
  methods: {
    isSystemAdmin,
    ...mapActions({
      begin: 'subject/begin',
      readSubjects: 'subject/readSubjects',
      updateSubjects: 'subject/updateSubjects',
      deleteSubjects: 'subject/deleteSubjects',
      importSubject: 'subject/importSubject',
      getSystemParameters: 'parameter/getAllData',
    }),
    async btnSearchClick() {
      this.isLoading = true
      if (
        this.departmentSelected !== null
        && this.departmentSelected !== undefined
      ) {
        this.filter.departmentId = this.departmentSelected.id
      } else {
        this.filter.departmentId = null
      }
      if (
        this.subjectTypeSelected !== null
        && this.subjectTypeSelected !== undefined
      ) {
        this.filter.subjectTypeId = this.subjectTypeSelected.id
      } else {
        this.filter.subjectTypeId = null
      }
      try {
        await this.getSubjectsFromStore()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onCreateSubject() {
      this.currentSubject = undefined
    },
    onEditSubject(subject) {
      const {
        rowNum, originalIndex, vgt_id, ...rest
      } = subject
      this.currentSubject = rest
    },
    onDeleteSubject(subject) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa môn học <span class="text-danger">${subject.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteSubjects(subject.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getSubjectsFromStore()
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getSubjectsFromStore()
    },
    async getSubjectsFromStore() {
      this.isLoading = true
      try {
        await this.readSubjects(this.filter)
        this.subjectsDisplay = this.subjects
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.subjectsDisplay.length; i++) {
          this.subjectsDisplay[i].alterId = []
          this.subjectsDisplay[i].conditionId = []
          if (this.subjectsDisplay[i].alterIds !== null) {
            this.subjectsDisplay[i].alterId = this.subjectsDisplay[i]
              .alterIds
              .split(',')
              .map(item => +item)
          }
          if (this.subjectsDisplay[i].conditionIds !== null) {
            this.subjectsDisplay[i].conditionId = this.subjectsDisplay[i]
              .conditionIds
              .split(',')
              .map(item => +item)
          }
          if (this.subjectsDisplay[i].previousIds !== null) {
            this.subjectsDisplay[i].previousId = this.subjectsDisplay[i]
              .previousIds
              .split(',')
              .map(item => +item)
          }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getSubjectsFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)
        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getSubjectsFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code.trim() })
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name.trim() })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      if (Object.hasOwn(columnFilters, 'subjectTypeId')) this.updateParams({ subjectTypeId: columnFilters.subjectTypeId })
      await this.getSubjectsFromStore()
    },
    getStatusName(id) {
      return this.statuses.find(status => status.id === id).name
    },
    getSubjectTypeName(id) {
      return this.subjectTypes.find(item => item.id === id).name
    },
    async onSucceed() {
      await this.getSubjectsFromStore()
    },

    async importExcel(e) {
      const { files } = e.target
      if (!files.length) {
        return
      } if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        // show err
      }
      if (files[0].name) {
        this.tenFile = files[0].name
      }
      const checkFileData = this.readFile(files)
      if (checkFileData && !checkFileData.status) {
        showErrorToast(this, 'Có lỗi xảy ra')
      }
    },
    readFile(files) {
      const res = {
        status: true,
        index: 0,
      }
      const fileReader = new FileReader()
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            header: 0,
            defval: '',
          })
          const excellist = []
          // Edit data
          if (ws.length > 0) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < ws.length; i++) {
              excellist.push(ws[i])
            }
          } else {
            showErrorToast(this, 'File không có dữ liệu')
            this.resetInputFile()
            return
          }
          if (
            !Object.hasOwn(excellist[0], 'MA_MON_HOC')
            || !Object.hasOwn(excellist[0], 'TEN_MON_HOC')
            || !Object.hasOwn(excellist[0], 'TEN_CHINH_THUC')
            || !Object.hasOwn(excellist[0], 'MA_KHOA')
            || !Object.hasOwn(excellist[0], 'MA_LOAI_MON_HOC')
            || !Object.hasOwn(excellist[0], 'SO_TC_LY_THUYET')
            || !Object.hasOwn(excellist[0], 'SO_TC_THUC_HANH')
            || !Object.hasOwn(excellist[0], 'SO_TC_THUC_TAP')
            || !Object.hasOwn(excellist[0], 'TINH_DIEM')
            || !Object.hasOwn(excellist[0], 'THI_LY_THUYET')
            || !Object.hasOwn(excellist[0], 'THI_THUC_HANH')
          ) {
            showErrorToast(this, 'File chưa đúng định dạng, vui lòng tải file mẫu')
            this.resetInputFile()
            return
          }
          this.dataExcel = []
          // eslint-disable-next-line no-plusplus
          for (let k = 0; k < excellist.length; k++) {
            const item = excellist[k]
            // eslint-disable-next-line no-bitwise
            if (!item.MA_MON_HOC || !item.TEN_MON_HOC || !item.MA_KHOA || !item.MA_LOAI_MON_HOC | !item.TEN_CHINH_THUC) {
              showErrorToast(this, `Dữ liệu đầu vào không được trống các trường thông tin [MA_MON_HOC, TEN_MON_HOC, MA_KHOA, MA_LOAI_MON_HOC, TEN_CHINH_THUC], Kiểm tra thông tin dòng ${k + 1}`)
              this.resetInputFile()
              return
            }
            let tongSoTietHoc = 0
            if (item.SO_TIET) {
              if (item.SO_TIET > 0) {
                tongSoTietHoc = item.SO_TIET
              }
            }
            tongSoTietHoc = (tongSoTietHoc > 0) ? tongSoTietHoc : parseFloat(this.tinChiThucHanh) * parseFloat(item.SO_TC_THUC_HANH || 0) + parseFloat(this.tinChiThucHanh) * parseFloat(item.SO_TC_THUC_TAP || 0) + parseFloat(this.tinChiLyThuyet) * parseFloat(item.SO_TC_LY_THUYET || 0)
            const obj = {
              rowNum: k + 1,
              code: item.MA_MON_HOC,
              name: item.TEN_MON_HOC,
              mainName: item.TEN_CHINH_THUC,
              departmentCode: item.MA_KHOA,
              subjectTypeCode: item.MA_LOAI_MON_HOC,
              theoryCreditNum: item.SO_TC_LY_THUYET === null || item.SO_TC_LY_THUYET.toString().trim() === '' ? 0 : item.SO_TC_LY_THUYET,
              practiceCreditNum: item.SO_TC_THUC_HANH === null || item.SO_TC_THUC_HANH.toString().trim() === '' ? 0 : item.SO_TC_THUC_HANH,
              internshipCreditNum: item.SO_TC_THUC_TAP === null || item.SO_TC_THUC_TAP.toString().trim() === '' ? 0 : item.SO_TC_THUC_TAP,
              countedForGpa: item.TINH_DIEM,
              totalCreditNum: item.SO_TC_QUY_DOI ? item.SO_TC_QUY_DOI : (parseFloat(item.SO_TC_THUC_HANH || 0) + parseFloat(item.SO_TC_THUC_TAP || 0) + parseFloat(item.SO_TC_LY_THUYET || 0)),
              // lessonNum: item.SO_TIET,
              lessonNum: tongSoTietHoc,
              // eslint-disable-next-line radix
              isTheoreticalExam: parseInt(item.THI_LY_THUYET || 0),
              // eslint-disable-next-line radix
              isPracticeExam: parseInt(item.THI_THUC_HANH || 0),
              orderNo: '',
              status: 1,
              delFlag: 0,
              createdBy: null,
            }
            this.dataExcel.push(obj)
          }
          this.showTableImport = true
          this.tableImport.data = this.dataExcel
          this.tableImport.totalRows = this.dataExcel.length
        } catch (e) {
          alert(`Read failure!${e}`)
        }
      }
      fileReader.readAsBinaryString(files[0])
      return res
    },
    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },
    async handleImportSubject() {
      if (this.checkDataBeforeImport(this.dataExcel)) {
        try {
          this.isLoading = true
          const res = await this.importSubject(this.dataExcel)
          if (res.code === 0) {
            showSuccessToast(this, 'Lưu thành công')
            await this.getSubjectsFromStore()
          } else {
            showErrorToast(this, res.message)
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.resetInputFile()
          this.showTableImport = false
          this.isLoading = false
        }
      }
    },

    checkDataBeforeImport(dataArray) {
      if (dataArray.length === 0) {
        showWarningToast(this, 'Chưa có dữ liệu để thực hiện')
        return false
      }
      const subjectCode = new Set()
      // Kiểm tra các điều kiện trong từng object của mảng
      for (const subArray of dataArray) {
        const {
          code, name, mainName, theoryCreditNum, practiceCreditNum, totalCreditNum, countedForGpa, departmentCode, subjectTypeCode,
        } = subArray
        // Kiểm tra các trường không được rỗng
        if (!code || !mainName || !name || (theoryCreditNum === null || theoryCreditNum === undefined || theoryCreditNum === '')
            || (practiceCreditNum === null || practiceCreditNum === undefined || practiceCreditNum === '') || !departmentCode || !subjectTypeCode
        ) {
          showWarningToast(this, 'Các trường thông tin [MA_MON_HOC, TEN_MON_HOC, TEN_CHINH_THUC, MA_KHOA, MA_LOAI_MON_HOC, SO_TC_LY_THUYET, SO_TC_THUC_HANH, TINH_DIEM] không được trống')
          return false
        }

        if (!totalCreditNum || parseInt(totalCreditNum) <= 0) {
          showWarningToast(this, 'Thông tin tổng số tín chỉ không được trống')
          return false
        }

        // Kiểm tra trường countedForGpa chỉ nhận giá trị '0', '1'
        if (countedForGpa.toString() !== '0' && countedForGpa.toString() !== '1') {
          showWarningToast(this, 'Thông tin trường TINH_DIEM vui lòng chỉ điền 0 hoặc 1')
          return false
        }

        if (subjectCode.has(code)) {
          showWarningToast(this, `Mã môn học  ${code} đang bị trùng lặp, vui lòng kiểm tra lại dữ liệu`)
          return false
        }

        subjectCode.add(code)
      }
      return true
    },

    downloadFile() {
      const columns = [
        { index: 1, width: 100 },
        { index: 2, width: 200 },
        { index: 3, width: 200 },
        { index: 4, width: 200 },
        { index: 5, width: 200 },
        { index: 6, width: 150 },
        { index: 7, width: 150 },
        { index: 8, width: 120 },
        { index: 9, width: 100 },
        { index: 10, width: 120 },
        { index: 11, width: 100 },
      ]
      const rows = []
      const headerRow = {
        index: 1,
        cells: [
          {
            index: 1,
            value: 'MA_MON_HOC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 2,
            value: 'TEN_MON_HOC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 3,
            value: 'TEN_CHINH_THUC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 4,
            value: 'MA_KHOA',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 5,
            value: 'MA_LOAI_MON_HOC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 6,
            value: 'SO_TC_LY_THUYET',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 7,
            value: 'SO_TC_THUC_HANH',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 8,
            value: 'SO_TC_THUC_TAP',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 9,
            value: 'TINH_DIEM',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 10,
            value: 'SO_TC_QUY_DOI',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 11,
            value: 'SO_TIET',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 12,
            value: 'THI_LY_THUYET',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 13,
            value: 'THI_THUC_HANH',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
        ],
      }
      const headerRow1 = {
        index: 2,
        cells: [
          {
            index: 1,
            value: '0101072',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 2,
            value: 'Đại số và hình học giải tích',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 3,
            value: 'Đại số và hình học giải tích',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 4,
            value: 'TH_SP',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 5,
            value: 'C',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 6,
            value: '2',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 7,
            value: '1',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 8,
            value: '0',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 9,
            value: '1',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 10,
            value: '3',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 11,
            value: 35,
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 12,
            value: 1,
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 13,
            value: 0,
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
        ],
      }

      const headerRow3 = {
        index: 4,
        cells: [
          {
            index: 1,
            value: 'Mã môn học phải là duy nhất',
            colSpan: 1,
          },
          {
            index: 2,
            value: '',
            colSpan: 1,
          },
          {
            index: 3,
            value: '',
            colSpan: 1,
          },
          {
            index: 4,
            value: 'Mã khoa xuất phát của môn học',
            colSpan: 1,
          },
          {
            index: 5,
            value: 'Mã loại môn học căn cứ theo danh mục loại môn học của nhà trường đã tạo',
            colSpan: 1,
          },
          {
            index: 6,
            value: 'Số tín chỉ lý thuyết',
            colSpan: 1,
          },
          {
            index: 7,
            value: 'Số tín chỉ thực hành',
            colSpan: 1,
          },
          {
            index: 8,
            value: 'Số tín chỉ thực tập',
            colSpan: 1,
          },
          {
            index: 9,
            value: '1: Có tính vào điểm GPA; 0: Không tính vào điểm GPA',
            colSpan: 1,
          },
          {
            index: 10,
            value: 'Số tín chỉ quy đổi là Tổng của Số tín chỉ lý thuyết + Số tín chỉ thực hành + Số tín chỉ thực tập',
            colSpan: 1,
          },
          {
            index: 11,
            value: 'Tổng số tiết học của môn học',
            colSpan: 1,
          },
          {
            index: 12,
            value: '1: Có tổ chức thi lý thuyết; 0: Không tổ chức thi lý thuyết',
            colSpan: 1,
          },
          {
            index: 13,
            value: '1: Có tổ chức thi thực hành; 0: Không tổ chức thi thực hành',
            colSpan: 1,
          },
        ],
      }

      rows.push(headerRow)
      rows.push(headerRow1)
      rows.push(headerRow3)
      const worksheets = [{ columns, rows }]
      const workbook = new Workbook({ worksheets }, 'xlsx')
      workbook.save('mauNhapHocPhan.xlsx')
    },

    showToast(title, icon, variant, autoHideDelay = 1000) {
      // bridge to unified helpers, keeping existing call sites simple
      if (variant === 'success') return showSuccessToast(this, title)
      if (variant === 'danger') return showErrorToast(this, title)
      if (variant === 'warning') return showWarningToast(this, title)
      return showInfoToast(this, title)
    },

    showCreditSummary(row) {
      return `${row.totalCreditNum} (${row.theoryCreditNum}_${row.practiceCreditNum}_${row.internshipCreditNum})`
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
